<script setup lang="ts">
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";
import { useField } from "vee-validate";

interface Props {
  modelValue?: any;
  name: string;
  label?: string;
  validateAs?: string;
  disabled?: boolean;
  placeholder?: string;
}

interface Emit {
  (event: "update:modelValue", value: string): void;
}

defineEmits<Emit>();

const props = withDefaults(defineProps<Props>(), {
  placeholder: "Enter a contact number",
});

const { value, errorMessage } = useField(() => props.name, props.validateAs, {
  syncVModel: true,
});

const updateValue = (newValue: string) => {
  if (!newValue && !value.value) return;
  value.value = newValue;
};

const inputOptions = {
  name: props.name,
  placeholder: props.placeholder,
};
</script>

<template>
  <div>
    <div v-auto-animate class="group" :class="{ 'opacity-50 select-none pointer-events-none cursor-default': disabled }">
      <label v-if="label" :for="name" class="px-1 text-xs group-focus-within:text-primary">{{ label }}</label>
      <vue-tel-input
        :model-value="value"
        @update:model-value="(newValue: string) => updateValue(newValue)"
        valid-characters-only
        :disabled="disabled"
        mode="international"
        class="h-form-input"
        :class="{ 'border-danger': errorMessage }"
        :auto-default-country="false"
        default-country="ZA"
        :name="name"
        :input-options="inputOptions"
      />
    </div>
    <InputError v-show="errorMessage">{{ errorMessage }}</InputError>
  </div>
</template>
